import { IOrderProduct } from '~/types/orders';
import { PRODUCT_TYPE } from '~/types/product';
import { productUtils } from '~/utils/productUtils';

export const previousOrderProductUnavailableMessage = (product: IOrderProduct | undefined): string | null => {
  if (!product) return null;

  const isMeal: boolean = product.type === PRODUCT_TYPE.MEAL_COMBO;

  const unavailableDueModifier: boolean = product.modifiers?.some(
    (modifier) => modifier.is_delete || !modifier.status || modifier.options?.some((option) => option.is_delete || !option.status)
  );
  const unavailableDueExclusion: boolean = product.exclusions?.some((item) => !item.status);
  const unavailableDueSize: boolean = Boolean(product.size && (product.size?.is_delete || !product.size?.status));
  const unavailableDueItems: boolean = Boolean(
    product.type && product.items?.some((item) => productUtils.getComboItemUnavailableMessage(item, isMeal))
  );

  switch (true) {
    case Boolean(product.out_of_stock):
    case unavailableDueItems:
      return 'out_of_stock';
    case unavailableDueModifier:
    case unavailableDueExclusion:
    case unavailableDueSize:
    case Boolean(!product.status || product.is_delete):
      return 'unavailable';
    default:
      return null;
  }
};
